<h1 class="mat-headline-small mb-1">Orders</h1>
<div class="d-flex mb-3">
  <orders-filters class="me-3 order-filters" />
  <button matButton="filled" class="align-self-center flex-shrink-0" (click)="columnPickerOpen.set(true)">
    <mat-icon>edit</mat-icon>
    Edit Columns
  </button>
</div>
<orders-report-summary class="mb-2" *ngrxLet="summaryCounts$ as summary" [summary]="summary" />
<orders-table-container class="flex-grow-1 overflow-auto" />
<ui-side-drawer [(isOpen)]="columnPickerOpen">
  <orders-column-picker [userColumns]="orderColumns()" (updateOrderColumns)="updateOrderColumns($event)" />
</ui-side-drawer>
